/**
 * Unwraps Babel-style CommonJS default exports when Rolldown exposes the
 * module namespace instead of the default value.
 */
export const resolveCjsDefault = <T>(value: T): T => {
  const module = value as T & { __esModule?: boolean; default?: T };

  return typeof value === 'object' && value !== null && module.__esModule && module.default !== undefined
    ? module.default
    : value;
};
